import {
  FileDownloadOutlined,
  VisibilityOffOutlined,
  VisibilityOutlined,
} from '@mui/icons-material';
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  Button,
  Typography,
} from '@mui/material';
import { ANNOTATION_PROVIDERS } from 'components/OrderSlidesList/ExtAnnotations/constants';
import { BLACK_ICON } from 'utilities/colors';
import { formatDateForExternalAnnotations } from 'utilities/dates_and_times';
import { DeleteIcon } from 'images/icons/DeleteIcon';
import { PercentageSlider } from 'components/Shared/PercantageSlider';
import { ANNOTATIONS_OPACITY_FIELD } from 'components/ImageViewer/constants';
import { ColorLegendButtons } from 'components/OrderSlidesList/ExtAnnotations/ColorLegendButtons';
import { AnnotationsLegend } from 'components/OrderSlidesList/ExtAnnotations/AnnotationsLegend';

export const AnnotationAccordion = ({
  handleChangeOpacity,
  annotation,
  visibleAnnotations,
  expandedRows,
  onToggleExpanded,
  onDownload,
  onChangeVisibility,
  preferences,
  dispatch,
  annotationsLegend,
  classes,
  colorLegend,
  onDeleteClick,
}) => {
  const isAnnotationVisible = visibleAnnotations.includes(annotation.uuid);
  const AnnotationsToggleIcon = isAnnotationVisible
    ? VisibilityOutlined
    : VisibilityOffOutlined;

  const isExpanded = expandedRows.includes(annotation.uuid);

  return (
    <Accordion
      disableGutters
      key={annotation.uuid}
      className={classes.accordion}
      expanded={isExpanded}
      onChange={() =>
        (isAnnotationVisible || isExpanded) && onToggleExpanded(annotation.uuid)
      }
    >
      <AccordionSummary classes={{ root: classes.accordionSummary }}>
        <Box width="100%">
          <Box
            display="flex"
            flexDirection="row"
            justifyContent="space-between"
            width="100%"
            height="3rem"
          >
            <Box className={classes.annotationTitle}>
              <Box className={classes.providerIconContainer}>
                <img
                  src={
                    ANNOTATION_PROVIDERS.find(
                      ({ provider }) => provider === annotation.provider,
                    )?.icon
                  }
                  className={classes.providerIconLarge}
                  alt="icon"
                />
              </Box>
              <Box>
                <Typography className={classes.annotationName}>
                  {annotation.file.name}
                </Typography>
                {annotation.uploaded_by && (
                  <Typography className={classes.annotationAuthor}>
                    Attached by {annotation.uploaded_by.first_name}{' '}
                    {annotation.uploaded_by.last_name} on{' '}
                    {formatDateForExternalAnnotations(annotation.created)}
                  </Typography>
                )}
              </Box>
            </Box>
            <Box>
              <Button
                className={classes.actionButton}
                onClick={(e) => onChangeVisibility(e, annotation.uuid)}
              >
                <AnnotationsToggleIcon />
              </Button>
              <Button
                className={classes.actionButton}
                onClick={() => onDownload(annotation.file.url)}
              >
                <FileDownloadOutlined />
              </Button>
              <Button
                className={classes.actionButton}
                onClick={(e) => onDeleteClick(e, annotation.uuid)}
              >
                <DeleteIcon color={BLACK_ICON} />
              </Button>
            </Box>
          </Box>
          {isAnnotationVisible && (
            <PercentageSlider
              className={classes.percentageSlider}
              value={
                preferences[ANNOTATIONS_OPACITY_FIELD]?.[annotation.uuid] || 100
              }
              handleChange={(event, newValue) =>
                handleChangeOpacity(event, annotation.uuid, newValue)
              }
            />
          )}
        </Box>
      </AccordionSummary>

      <AccordionDetails>
        <ColorLegendButtons
          colorLegend={colorLegend}
          preferences={preferences}
          dispatch={dispatch}
          uuid={annotation.uuid}
          classes={classes}
        />
        {annotationsLegend?.uuid === annotation?.uuid && (
          <AnnotationsLegend annotationsLegend={annotationsLegend} />
        )}
      </AccordionDetails>
    </Accordion>
  );
};
